import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/auth.service.ts';
import { getEmailVerificationStatus } from '../utils/emailVerification.ts';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const verification = getEmailVerificationStatus(authService.getUser());
  const onVerifyPage = location.pathname.startsWith('/verify-email');

  // 3 günlük süre dolduktan sonra panel kilitlenir
  if (verification.isLocked && !onVerifyPage) {
    return <Navigate to="/verify-email" replace />;
  }

  return <>{children}</>;
}

export default PrivateRoute;
